export default "__VITE_ASSET__beeb9d41__"